export class SchemaBuilderStrings {
  static primaryKeyDescription = 'A unique column which uniquely identifies a row in your table. Hevo uses the Primary Key to ' +
    'determine if a row needs to be inserted or updated. If your table has a row with the same primary key value, ' +
    'the row is updated else it is inserted.';

  static bigqueryPartitionKeyDescription = 'Partitioning divides your table into smaller segments. ' +
    'Query using the partitioning column reduces the amount of data scanned, which can control costs & improve query performance.';

  static distKeyDescription = 'Distribution key determines how the data is distributed among Amazon Redshift compute nodes.';

  static sortKeyDescription = 'Amazon Redshift stores your data on disk in sorted order according to the Sort Key';

  static clusterKeyDescription = 'Cluster key determines how the data is distributed in micro partitions.';

  static creatingTable = {
    icon: 'syncing',
    title: 'Creating Table... 😊',
    body: 'Your Table is being created, it may take some time, please wait'
  };

  static mappingToCreatedTable = {
    icon: 'schema-mapper',
    title: 'Mapping your Table 🤩',
    body: 'Table created successfully and we are Mapping your Table. This may take few seconds'
  };
}

export const FACT_TABLE_TYPE_DESCRIPTION =
  'FACT tables should be used for larger and most granular tables. It is recommended to define very large tables as FACT.';
export const DIMENSION_TABLE_TYPE_DESCRIPTION =
  'DIMENSION tables should be used for the smaller tables that are more descriptive in nature and are joined with the FACT tables. ' +
  'It is recommended to define smaller tables as DIMENSION.';
